// removed by extract-text-webpack-plugin
module.exports = {"loader":"Loading_loader---sbox","text":"Loading_text---sbox","shape":"Loading_shape---sbox","blink":"Loading_blink---sbox","dark":"Loading_dark---sbox","light":"Loading_light---sbox","round":"Loading_round---sbox"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Loading/styles.less
// module id = 543
// module chunks = 0